<radio [(ngModel)]="value" value="Angular" name="radioInlineDemo" [inline]="true">Angular</radio>
<radio [(ngModel)]="value" value="React" name="radioInlineDemo" [inline]="true">React</radio>
<radio [(ngModel)]="value" value="Vue" name="radioInlineDemo" [inline]="true">Vue</radio>